const state = {
    isLogin: false, // 是否登录
}
const mutations = {
    SET_LOGIN_STATUS: (state, payload) => {
        state.isLogin = payload;
        localStorage.setItem('isLogin', payload)
    },
    GET_LOGIN_STATUS: () => {
        localStorage.getItem('isLogin')
    },
    CLEAR_LOGIN_STATUS(state) {
        state.isLogin = false;
        localStorage.removeItem('isLogin')
    },
}
const actions = {
    login({ commit }, { isLogin, userId }) {
        commit('SET_LOGIN_STATUS', isLogin)
    },
    logout({ commit }) {
        commit('CLEAR_LOGIN_STATUS')
        delCookie('BI_TOKEN');
    },
    initializeStore({ commit }) {
        const isLogin = commit('GET_LOGIN_STATUS');
        commit('SET_LOGIN_STATUS', isLogin)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}